export default "__VITE_ASSET__D9F3oMKH__"